'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ContactsInfoBox;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AccordionTransition = require('UIComponents/transitions/AccordionTransition');

var _AccordionTransition2 = _interopRequireDefault(_AccordionTransition);

var _UITile = require('UIComponents/tile/UITile');

var _UITile2 = _interopRequireDefault(_UITile);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledUITile = (0, _styledComponents2.default)(_UITile2.default).withConfig({
  displayName: 'ContactsInfoBox__StyledUITile'
})(['margin-top:24px;font-size:12px;padding:16px;background-color:', ';'], _colors.GYPSUM);

function ContactsInfoBox(_ref) {
  var titleKey = _ref.titleKey,
      content = _ref.content,
      showBox = _ref.showBox;

  return _react2.default.createElement(
    _AccordionTransition2.default,
    { open: showBox },
    _react2.default.createElement(
      StyledUITile,
      null,
      _react2.default.createElement(
        'div',
        { style: { fontWeight: 500 } },
        _react2.default.createElement(_FormattedMessage2.default, { message: titleKey })
      ),
      content
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/info-box/ContactsInfoBox.js
// module id = 682
// module chunks = 3 4